/**
 * @date: 2/28/20
 * @author: Yan Wang <ywang@max.md>
 * @copy: (C) Copyright 2020 MaxMD Corporation, All Rights Reserved.
 */


import React, {useEffect, useState} from "react";
import Alert from '@mui/material/Alert';
import {Button, Container, alpha} from "@mui/material";
// import '../Home.css';
import './Auth.css';
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import makeStyles from '@mui/styles/makeStyles';

import {getQueryParams, handleHttpResponse, handleHttpResponseAcceptAuthError} from "../utils/http-helpers";
import AlertTitle from '@mui/material/AlertTitle';
import TextField from "@mui/material/TextField";
import ShowMessage from "../utils/show-message";
import CircularProgress from "@mui/material/CircularProgress";
import {PortalUrl} from "../utils/portal-urls";
// import IdmeSignImg from './images/signin-with-idme-green.png'

const useStyles = makeStyles((theme) => ({
    formRoot: {
        width: '100%',
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            // width: '25ch',
            width: '90%'
        },
    },
    grow: {
        flexGrow: 1,
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    title: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'block',
        },
    },
    search: {
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
            backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginRight: theme.spacing(2),
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
            marginLeft: theme.spacing(3),
            width: 'auto',
        },
    },
    searchIcon: {
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    inputRoot: {
        color: 'inherit',
    },
    inputInput: {
        padding: theme.spacing(1, 1, 1, 0),
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        width: '100%',
        [theme.breakpoints.up('md')]: {
            width: '20ch',
        },
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 350,
    },
    formInput: {
        margin: theme.spacing(1),
        // minWidth: '100%',
    },
    loginButton: {
        minHeight: 56,
        width: 300,
        // minWidth: '100%',
        fontSize: 20,
        fontWeight: 'bold',
        textTransform: 'none',
        marginBottom: 10
    },
    forgotPwdButton: {
        textTransform: 'none'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff'
    },
    testAlignLeft: {
        textAlign: 'left'
    },
    signInButtonWrapper: {
        whiteSpace: 'nowrap', marginBottom: 15
    },
    signInButton: {
        width: 292, height: 60, marginRight: 0, whiteSpace: 'nowrap'
    }
    // signInButton: {
    //     width: 125, height: 45, marginRight: 10, whiteSpace: 'nowrap'
    // }
}));

export default function SignInWithBasicAuth(props) {
    const handleBasicLoginCompleted = props.handleBasicLoginCompleted;
    const account = props.account || {};
    const queryParams = getQueryParams();
    const sessionTimedout = props.sessionTimedout;
    const classes = useStyles();

    const [msg, setMsg] = useState({});
    const [loginLoading, setLoginLoading] = useState(null);


    const [form, setForm] = useState({
        organizationUsername: queryParams.o || "",
        username: queryParams.u || ""
    });
    const handleFormFieldChanged = (name, value) => {
        const newParams = {...form};
        newParams[name] = value;
        setForm(newParams);
    }
    const handleFormKeypress = (e) => {
        if (e.key === "Enter"){
            handleLogin()
        }
    }
    const submitLoginForm = () => {
        setLoginLoading('Loading');
        const url = `/auth/basic`;
        const requestOption = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(form)
        };
        console.log(`POST ${url}`, requestOption);

        fetch(url, requestOption)
        .then(handleHttpResponseAcceptAuthError)
        .catch( (err) => {
            console.error('Login failed', err);
            setLoginLoading(null);
            if (err){
                setMsg({error: `Login failed: ${err}`});
            }
            return false;
        }).then ( (res) => {
            if (res){
                console.log(res);
                const gotoUrl = window.location.href;
                window.location.href = gotoUrl;
                return ;
            }
        });
    }
    const handleLogin = () => {
        if (!loginLoading){
            if (form.organizationUsername && form.username && form.password){
                submitLoginForm();
            } else {
                setMsg({warning: 'Please enter Username/Password!'});
                return;
            }
        }
    }


    var idmeAuthorizeUrl = `${PortalUrl.SignInWithIdme}?url=`;
    var googleAuthorizeUrl = `${PortalUrl.SignInWithGoogle}?url=`;
    var linkedInAuthorizeUrl = `${PortalUrl.SignInWithLinkedIn}?url=`;
    if (queryParams.error && window.location.pathname == "/"){
        idmeAuthorizeUrl += encodeURIComponent(queryParams.url || "/");
        googleAuthorizeUrl += encodeURIComponent(queryParams.url || "/");
        linkedInAuthorizeUrl += encodeURIComponent(queryParams.url || "/");
    } else {
        idmeAuthorizeUrl += encodeURIComponent(window.location.pathname + window.location.search);
        googleAuthorizeUrl += encodeURIComponent(window.location.pathname + window.location.search);
        linkedInAuthorizeUrl += encodeURIComponent(window.location.pathname + window.location.search);
    }
    // const authorizeUrl = "/auth/signIn?url=" + encodeURIComponent(window.location.pathname + window.location.search);

    return (
        <Container className='auth-container' maxWidth='xs' >
            <div className='logo-wrapper'>
                <img width={300} src={require('../images/dt-logo.png')?.default}/>
            </div>
            {/*<br/>*/}
            {/*<img src={require('../images/dt-logo.png')}/>*/}
            {/*<br/><br/>*/}
            <h3 className='auth-title'>Directory Admin Portal</h3>

            {account && account.user && account.user.status === 'disabled' && <Alert color='warning' icon={false}>Your account has been disabled by the administrator.</Alert> }
            {account && account.user && account.user.status === 'pending' && <Alert color='warning' icon={false}>Your account is not activated.</Alert> }
            {/*<Alert severity="info" icon={false}> {sessionTimedout && "Session timed out."} Sign in to the MaxMD Certificate Portal.</Alert>*/}

            {queryParams && queryParams.error &&
            <Alert severity="warning" className={classes.testAlignLeft}>
                <AlertTitle> <strong>{queryParams.error} {queryParams.errorTitle || ""}</strong> </AlertTitle>
                {queryParams.errorDescription || ""}
            </Alert>
            }

            <form className={classes.formRoot} noValidate autoComplete="off" onSubmit={(e) => e.preventDefault()}>
                <ShowMessage msg={msg} />
                <div>
                    <TextField className={classes.formInput}
                               variant="standard"
                               label="Enter Username" type='text'
                               onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('username',e.target.value) } />
                </div>
                <div>
                    <TextField className={classes.formInput}
                               variant="standard"
                               label="Enter Password" type='password'
                               onKeyPress={handleFormKeypress} onChange={(e) => handleFormFieldChanged('password',e.target.value) } />
                </div>
                <br/>
                <div>
                    <Button className={classes.loginButton} size='large' variant='contained' color='primary' onClick={handleLogin} disabled={Boolean(loginLoading)} >
                        {loginLoading ? <><CircularProgress color={"inherit"} /> {loginLoading} ...</> : <>Sign In to Admin Portal</>}
                    </Button>
                    <Button className={classes.forgotPwdButton} size='large' variant='text' color='primary' target='_self'
                            href={`/forgotPassword?back=${encodeURIComponent(window.location.pathname + window.location.search)}`} >Forgot Password</Button>
                </div>
            </form>

            <div className='or-bar' >
                <span>Or sign in with</span>
            </div>

            <div className={classes.signInButtonWrapper}>
                <Button className={classes.signInButton} variant='outlined' color='primary' href={googleAuthorizeUrl}>
                    <img src={require('../images/google-logo.svg')?.default} width={40}/> &nbsp; Sign In with Google
                </Button>
            </div>
            {/*<div className={classes.signInButtonWrapper}>*/}
            {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={idmeAuthorizeUrl}>*/}
            {/*        <img src={require('../images/IDme-Logo.png')} height={22}/>*/}
            {/*    </Button>*/}
            {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={googleAuthorizeUrl}>*/}
            {/*        <img src={require('../images/google-logo.svg')} width={22}/> &nbsp; Google*/}
            {/*    </Button>*/}
            {/*    <Button className={classes.signInButton} variant='outlined' color='primary' href={linkedInAuthorizeUrl}>*/}
            {/*        <img src={require('../images/linkedin-logo.svg')} width={19}/> &nbsp; LinkedIn*/}
            {/*    </Button>*/}
            {/*</div>*/}

        </Container>

    );
}

